module.exports = __webpack_public_path__ + "static/media/DT-UK-LOGO-2024.07d00e81.png";